

(function () {
  'use strict';

  window.toggleMobileNav = function () {
    var nav = document.getElementById('nav');
    var scrim = document.getElementById('navScrim');
    var toggle = document.querySelector('.menu-toggle');
    if (!nav) return;
    var isOpen = nav.classList.toggle('is-open');
    if (scrim) scrim.classList.toggle('show', isOpen);
    if (toggle) toggle.setAttribute('aria-expanded', isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
  };
  window.closeMobileNav = function () {
    var nav = document.getElementById('nav');
    var scrim = document.getElementById('navScrim');
    var toggle = document.querySelector('.menu-toggle');
    if (!nav) return;
    nav.classList.remove('is-open');
    if (scrim) scrim.classList.remove('show');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeMobileNav();
  });

  var toastTimer;
  window.showToast = function (msg, kind) {
    var toast = document.getElementById('ToastEl');
    if (!toast) return;
    toast.innerHTML = (kind === 'error' ? '⚠ ' : '✓ ') + '<span>' + msg + '</span>';
    requestAnimationFrame(function () { toast.classList.add('show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 1800);
  };

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  window.updateCartBadge = function () {
    fetchCart().then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-zero', cart.item_count === 0);
      });
    }).catch(function () {});
  };

  window.cartAdd = function (form, options) {
    options = options || {};
    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var formData = new FormData(form);
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.data && res.data.description) || 'Could not add to cart';
          window.showToast(msg, 'error');
          return null;
        }
        window.showToast('Added to cart');
        window.updateCartBadge();
        if (options.checkout) {
          window.location.href = '/checkout';
        } else if (options.redirect) {
          window.location.href = '/cart';
        }
        return res.data;
      })
      .catch(function () { window.showToast('Network error', 'error'); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      });
  };

  window.cartChange = function (key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.updateCartBadge();
        return cart;
      });
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
    var input = btn.parentElement.querySelector('input[name="quantity"], input.qty-input');
    if (!input) return;
    var newVal = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = newVal;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function quickAddButton(form) {
    return form.querySelector('[data-quick-add-button]');
  }

  function renderQuickStepper(form, key, qty) {
    var addBtn = quickAddButton(form);
    if (!addBtn) return;
    var wrap = addBtn.parentElement;
    var existing = wrap.querySelector('.product-card__qty-stepper');
    if (existing) existing.remove();
    addBtn.style.display = 'none';

    var stepper = document.createElement('div');
    stepper.className = 'product-card__qty-stepper';
    stepper.setAttribute('data-line-key', key);
    stepper.innerHTML = '<button type="button" aria-label="Decrease quantity" data-quick-qty="-1">−</button>' +
      '<span class="product-card__qty-value" aria-live="polite">' + qty + '</span>' +
      '<button type="button" aria-label="Increase quantity" data-quick-qty="1">+</button>';
    wrap.insertBefore(stepper, wrap.firstChild);
  }

  function restoreQuickAdd(form) {
    var stepper = form.querySelector('.product-card__qty-stepper');
    if (stepper) stepper.remove();
    var addBtn = quickAddButton(form);
    if (addBtn) {
      addBtn.style.display = '';
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart';
    }
  }

  function syncQuickFormFromCart(form) {
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return Promise.resolve();
    var variantId = String(idInput.value);
    return fetchCart().then(function (cart) {
      var item = cart.items.find(function (line) { return String(line.variant_id) === variantId; });
      if (item && item.quantity > 0) renderQuickStepper(form, item.key, item.quantity);
      else restoreQuickAdd(form);
    }).catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-product-form]')) return;
    e.preventDefault();

    if (form.matches('[data-quick-add]')) {
      window.cartAdd(form, { redirect: false }).then(function (item) {
        if (item) syncQuickFormFromCart(form);
      });
      return;
    }

    window.cartAdd(form, { redirect: true });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-qty]');
    if (!btn) return;
    e.preventDefault();
    var stepper = btn.closest('.product-card__qty-stepper');
    var form = btn.closest('form[data-quick-add]');
    if (!stepper || !form) return;

    var key = stepper.getAttribute('data-line-key');
    var valueEl = stepper.querySelector('.product-card__qty-value');
    var current = parseInt(valueEl ? valueEl.textContent : '0', 10) || 0;
    var delta = parseInt(btn.getAttribute('data-quick-qty'), 10) || 0;
    var next = Math.max(0, current + delta);

    stepper.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    window.cartChange(key, next).then(function () {
      if (next === 0) restoreQuickAdd(form);
      else if (valueEl) valueEl.textContent = next;
      window.showToast(next === 0 ? 'Removed from cart' : 'Cart updated');
    }).catch(function () {
      window.showToast('Could not update cart', 'error');
    }).finally(function () {
      stepper.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
    });
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('[data-cart-qty]')) return;
    var key = input.getAttribute('data-key');
    var qty = parseInt(input.value, 10) || 0;
    window.cartChange(key, qty).then(function () { window.location.reload(); });
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-key');
    window.cartChange(key, 0).then(function () { window.location.reload(); });
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches('[data-variant-option]')) return;
    var form = input.closest('form[data-product-form]');
    if (!form) return;
    var optionInputs = form.querySelectorAll('[data-variant-option]:checked');
    var selectedOptions = Array.from(optionInputs).map(function (i) { return i.value; });
    var variants = JSON.parse(form.getAttribute('data-variants') || '[]');
    var match = variants.find(function (v) {
      return v.options.length === selectedOptions.length &&
        v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
    });
    if (match) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) priceEl.textContent = match.price_formatted;
      var compareEl = document.querySelector('[data-product-compare-price]');
      if (compareEl) {
        compareEl.textContent = match.compare_at_price_formatted || '';
        compareEl.style.display = match.compare_at_price > match.price ? '' : 'none';
      }
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }
  });

  function wireCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('.carousel');
      var prev = wrap.querySelector('.carousel__nav--prev');
      var next = wrap.querySelector('.carousel__nav--next');
      if (!track) return;
      if (prev) prev.onclick = function () { track.scrollBy({ left: -track.clientWidth * 0.7, behavior: 'smooth' }); };
      if (next) next.onclick = function () { track.scrollBy({ left:  track.clientWidth * 0.7, behavior: 'smooth' }); };
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-large]');
    if (!btn) return;
    var main = document.getElementById('MainProductImage');
    if (!main) return;
    e.preventDefault();
    main.src = btn.getAttribute('data-large');
    document.querySelectorAll('.pd-thumb').forEach(function (b) { b.classList.remove('active'); });
    if (btn.classList.contains('pd-thumb')) btn.classList.add('active');
    if (!btn.classList.contains('pd-thumb')) {
      var matchingThumb = document.querySelector('.pd-thumb[data-large="' + btn.getAttribute('data-large') + '"]');
      if (matchingThumb) matchingThumb.classList.add('active');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    window.updateCartBadge();
    wireCarousels();
    document.querySelectorAll('form[data-quick-add]').forEach(function (form) {
      syncQuickFormFromCart(form);
    });
  });
})();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    var form = btn.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    window.cartAdd(form, { checkout: true });
  });



/* ZoraCook final mobile helpers */
(function () {
  function closeDrawerSafe() {
    if (typeof window.closeDrawer === 'function') window.closeDrawer();
    if (typeof window.closeMobileNav === 'function') window.closeMobileNav();
  }
  document.addEventListener('click', function (e) {
    var drawer = document.getElementById('drawer');
    if (!drawer) return;
    if (e.target.closest('.drawer__list a')) closeDrawerSafe();
  }, { passive: true });

  window.addEventListener('orientationchange', function () {
    setTimeout(function () {
      document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
    }, 250);
  });

  function setVh() {
    document.documentElement.style.setProperty('--vh', (window.innerHeight * 0.01) + 'px');
  }
  setVh();
  window.addEventListener('resize', setVh, { passive: true });
})();
